import MTilesRow from './m-tiles-row';

export default MTilesRow;